import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

// Not a password-reset code: a claim can only set a first password, never overwrite an existing one.
export const claimSignup = async (claimToken: string, password: string) => {
  const claim = httpsCallable<
    { claimToken: string; password: string },
    { email: string }
  >(getFunctions(), 'stripe-claimSignup');

  const { data } = await claim({ claimToken, password });

  return data;
};
